<template>
  <div>
    <div class="program-panel">
      <draggable-window ref="draggableWindowRef" title="小程序" :visible="programVisible" @close="cancel" :height="divHeight" :width="divWidth">
        <div class="program-detail">
          <div class="app-list">
            <a-card
                class="group-item"
                v-for="group in groupAppList"
                :key="group.name"
                :title="group.name"
            >
              <a-card-grid
                  class="app-item"
                  v-for="app in group.appList"
                  :key="app.id"
                  @click="programIframe(app)"
              >
                <img :src="filePreview(app.icon)" alt=""/>
                <span>{{ app.name }}</span>
              </a-card-grid>
            </a-card>
          </div>
        </div>
      </draggable-window>
    </div>
    <template v-for="iframe in programList">
      <program-preview
	      @show="handleProgramClick(iframe)"
        :key="iframe.code"
        :url="iframe.appUrl"
        v-model="iframe.visible"
	      :z-index="iframe.zIndex"
        :id="iframe.id"
      >
      </program-preview>
    </template>
  </div>
</template>

<script>
import DraggableWindow from '@/components/zjy/DragModal.vue'
import {getAppCurrentWorkbench} from "@/api/home-app";
import ProgramPreview from "@/views/home/program/ProgramPreview.vue";
import {mapState} from "vuex";
export default {
	name: "programPanel",
  components: {DraggableWindow, ProgramPreview },
  computed: {
    ...mapState({
      programList: state => state.tabs.programIframeList,
    }),
    divHeight() {
      return this.windowHeight * 0.9;
    },
    divWidth() {
      return (this.divHeight / 130) * 69;
    },
  },
	data() {
		return {
      windowHeight: window.innerHeight,
      programVisible: false,
      groupAppList: []
		}
	},
  mounted() {
    window.addEventListener('resize', this.updateWindowHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowHeight);
  },
  methods: {
    updateWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
		show() {
      this.programVisible = true
      this.getCurrentWorkbench()
		},
    cancel () {
      this.programVisible = false
    },
    getCurrentWorkbench() {
      const param = {
        group: ''
      }
	    getAppCurrentWorkbench(param).then(res => {
        if (res.success) {
          this.groupAppList = res.data.groupAppList
        }
      })
    },
    programIframe(data) {
			const iframe = {
        id: data.id,
        code: data.code,
        appUrl: data.appUrl,
        name: data.name,
        icon: data.icon,
        visible: true,
				zIndex: 1
      }
      this.$store.dispatch('AddProgramIframe', iframe)
    },
	  handleProgramClick(iframe) {
		  const maxZIndex = Math.max(...this.programList.map(program => program.zIndex || 1)) || 1
		  iframe.zIndex = maxZIndex + 1
	  }
	}
}
</script>


<style scoped lang="less">
.program-panel {
  .draggable-window {
    background: #EDEDED;
  }
  .program-detail {
    height: 100%;
    overflow: auto;
    padding: 0 20px 10px;
    /* 整个滚动条 */
    &::-webkit-scrollbar {
      /* 对应纵向滚动条的宽度 */
      width: 0px;
      /* 对应横向滚动条的宽度 */
      height: 0px;
    }
    .app-list {
      width: 100%;

      .group-item {
        margin-bottom: 10px;
        border-color: #ececec;
        padding: 0 15px 7px 15px;
        border-radius: 4px;
        /deep/.ant-card-head {
          padding: 0;
          color: #333345;
          height: 40px;
          //border-color: #ececec;
          border: 0;
          min-height: 40px;
          margin-bottom: 7px;
          .ant-card-head-title{
            padding: 15px 0 0;
            font-size: 14px;
            color: #737373;
          }
        }
        /deep/.ant-card-body {
          display: flex;
          flex-wrap: wrap;
        }
        .app-item {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          width: 25%;
          //height: 85px;
          border: 0;
          box-shadow: unset;
          margin: 0;
          padding: 9px 0;
          text-align: center;
          img {
            margin-bottom: 6px;
            height: 32px;
            width: 32px;
            border-radius: 4px;
          }

          span {
            font-size: 12px;
            color: #787889;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            padding: 0 4px;
          }
          &:hover {
            background: rgb(242,242,242);
            cursor: pointer;
            border-radius: 6px;
          }
        }
      }
    }
  }
}
</style>
